<template>
  <div :class="`chat-box chat-box--${theme} ${hideInput ? 'hideInput' : ''}`">
    <div
      class="chat-box-user-identity"
      v-if="theme == 'live' && user.length == 0"
    >
      <div class="identity-container">
        <p class="identity-copy">Give us your deets to get involved</p>
        <IdentityInput v-model="identity" @submit="submitIdentity" />
      </div>
    </div>
    <beautiful-chat
      :participants="participants"
      :onMessageWasSent="onMessageWasSent"
      :messageList="messageList"
      :isOpen="true"
      :close="() => true"
      :open="() => true"
      :showEmoji="true"
      :showFile="false"
      :showLauncher="false"
      :showCloseButton="true"
      :colors="colors"
      :alwaysScrollToBottom="!preventScroll"
      :messageStyling="true"
    >
      <template v-slot:header v-if="messageType == 'pending'">
        <p>PENDING MESSAGES</p>
      </template>
      <template v-slot:header v-else>
        <div class="sc-header__content">
          <img src="@/assets/hairparty.svg" />
        </div>
      </template>
      <template v-slot:text-message-body="{ message }">
        <div :class="message">
          <p class="sc-message__author">{{ message.author }}</p>
          <p>{{ message.data.text }}</p>
        </div>
      </template>
      <template v-if="isMod" v-slot:text-message-toolbox="scopedProps">
        <ModTools
          :message="scopedProps.message"
          :canUndo="!canApprove"
          :canApprove="canApprove"
        />
      </template>
    </beautiful-chat>
  </div>
</template>

<script>
import { mapState } from "vuex"

import ModTools from "./ModTools"
import IdentityInput from "@/components/IdentityInput"

import colors from "./colors"

export default {
  name: "Chat",
  data() {
    return {
      typeState: "default",
      identity: {
        name: "",
        email: ""
      },
      colors
    }
  },

  props: {
    isMod: Boolean,
    canApprove: Boolean,
    preventScroll: Boolean,
    theme: {
      type: String,
      default: "live"
    },
    messageType: String,
    chatType: String,
    sendToPending: {
      type: Boolean,
      default: false
    }
  },

  components: {
    ModTools,
    IdentityInput
  },

  methods: {
    submitIdentity() {
      this.$store.dispatch("identityStore/setIdentity", [
        this.identity.name,
        this.identity.email
      ])
    },
    mapMessage({ userId, id, text, colorCode, userName }) {
      return {
        messageId: id,
        type: "text",
        userId,
        author: userName,
        colorCode,
        data: {
          text
        }
      }
    },
    mapMember({ id, name }) {
      return {
        id,
        name,
        imageUrl:
          "https://images.unsplash.com/photo-1541949432307-5b17dd371cf4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2256&q=80"
      }
    },
    onMessageWasSent({ data, type }) {
      const userName = this.theme == "mod" ? "Bleach London" : this.user
      const action = this.sendToPending
        ? "chatStore/sendPendingMessage"
        : "chatStore/sendMessage"

      this.$store.dispatch(action, [
        type == "text" ? data.text : data.emoji,
        this.userId,
        userName
      ])
    }
  },
  computed: mapState({
    userId({ identityStore }) {
      return identityStore.localStorageId
    },
    user({ identityStore }) {
      return identityStore.name
    },
    messageList({ chatStore }) {
      if (this.messageType == "pending") {
        return chatStore.pendingMessages.map(this.mapMessage)
      } else {
        return chatStore.messages.map(this.mapMessage)
      }
    },
    participants({ chatStore }) {
      return chatStore.users
        .map(this.mapMember)
        .filter(({ id }) => id != this.user)
    },
    hideInput({ chatStore }) {
      return chatStore.hideInput
    }
  })
}
</script>
